import { size, trim, get } from 'lodash';

import { verificaEnquadramentoDefinicao } from 'utils/tools';

import {
	E_DEMOLICAO_PARCIAL,
	E_DEMOLICAO_TOTAL,
	PERGUNTAS_DEMOLICAO_TOTAL_POR_ENDERECO,
	E_DESMEMBRAMENTO_UNIFICACAO,
	E_DESMEMBRA_UNIFICA_RECICLA_USO_PARCIAL,
	E_RECICLAGEM_USO_TOTAL,
	E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL,
	E_RECICLAGEM_USO_PARCIAL
} from './indexNovo';

export const validarLimpar = (data, definicao) => {
	let errors = {};

	// Validação para Demolição Total
	if (verificaEnquadramentoDefinicao([E_DEMOLICAO_TOTAL], definicao)) {
		const areasPorEndereco = data.areasPorEndereco || {};
		const chavesEnderecos = Object.keys(areasPorEndereco);
		let countEnderecosPreenchidosCorretamente = 0;
		let algumEnderecoIniciadoMasIncompleto = false;

		// Verifica se o formulário principal (obtido via 'formulario.formData.data.enderecoCdlList' no frontend)
		// possui endereços, para sabermos se a validação de "pelo menos um" se aplica.
		// No objeto 'data' passado para 'validarLimpar', essa lista de endereços do formulário não está diretamente disponível,
		// então confiamos que 'chavesEnderecos' reflete os endereços que o usuário pode preencher.
		const numeroDeEnderecosDisponiveisParaPreenchimento = get(
			data,
			'_frontendState.formContext.formData.data.enderecoCdlList.length',
			chavesEnderecos.length
		);
		// Nota: Passar o número de endereços do CDL List para 'data' seria mais robusto,
		// por exemplo, data.numeroEnderecosCdlList. Por agora, usaremos chavesEnderecos.length.

		if (chavesEnderecos.length > 0) {
			errors.areasPorEndereco = {}; // Objeto para armazenar erros específicos de cada endereço

			chavesEnderecos.forEach(enderecoKey => {
				const dadosEndereco = areasPorEndereco[enderecoKey];
				const errosDoEnderecoAtual = {};
				let esteEnderecoFoiIniciado = false;
				let esteEnderecoEstaValido = true;

				// Verifica se alguma área foi marcada e validada
				let algumaAreaMarcadaEValida = false;
				let algumaAreaApenasMarcada = false; // Flag para saber se o usuário marcou algum checkbox de área

				PERGUNTAS_DEMOLICAO_TOTAL_POR_ENDERECO.forEach(pergunta => {
					if (dadosEndereco[pergunta.cbFieldName]) {
						esteEnderecoFoiIniciado = true;
						algumaAreaApenasMarcada = true;
						if (
							!dadosEndereco[pergunta.areaFieldName] ||
							!dadosEndereco[pergunta.areaFieldName].value ||
							parseFloat(String(dadosEndereco[pergunta.areaFieldName].value).replace(',', '.')) <= 0
						) {
							errosDoEnderecoAtual[pergunta.areaFieldName] = ['A metragem deve ser informada e maior que zero.'];
							esteEnderecoEstaValido = false;
						} else {
							algumaAreaMarcadaEValida = true;
						}
					}
				});

				// Outros campos também podem indicar que o endereço foi iniciado
				if (dadosEndereco.tipoConstrucao && dadosEndereco.tipoConstrucao.codigo) esteEnderecoFoiIniciado = true;
				if (dadosEndereco.numeroMatricula && trim(dadosEndereco.numeroMatricula.value)) esteEnderecoFoiIniciado = true;
				if (dadosEndereco.emissaoMatricula && trim(dadosEndereco.emissaoMatricula.value))
					esteEnderecoFoiIniciado = true;
				if (dadosEndereco.zonaMatricula && trim(dadosEndereco.zonaMatricula.value)) esteEnderecoFoiIniciado = true;

				if (esteEnderecoFoiIniciado) {
					// Se o endereço foi iniciado, todos os campos obrigatórios são validados
					if (!algumaAreaApenasMarcada) {
						// Nenhuma área foi marcada, mas outros campos foram
						// Adiciona erro a um campo genérico ou ao primeiro checkbox de área para feedback
						errosDoEnderecoAtual[PERGUNTAS_DEMOLICAO_TOTAL_POR_ENDERECO[0].cbFieldName] = [
							'Ao menos uma opção de área deve ser marcada e sua metragem preenchida.'
						];
						esteEnderecoEstaValido = false;
					} else if (algumaAreaApenasMarcada && !algumaAreaMarcadaEValida) {
						// Se alguma área foi marcada, mas nenhuma delas tem metragem válida.
						// Os erros individuais de metragem já foram adicionados.
						// esteEnderecoEstaValido já deve estar false.
					}

					if (!dadosEndereco.tipoConstrucao || !dadosEndereco.tipoConstrucao.codigo) {
						errosDoEnderecoAtual.tipoConstrucao = ['O tipo de material é obrigatório.'];
						esteEnderecoEstaValido = false;
					}
					if (!dadosEndereco.numeroMatricula || !trim(dadosEndereco.numeroMatricula.value)) {
						errosDoEnderecoAtual.numeroMatricula = ['O número da matrícula é obrigatório.'];
						esteEnderecoEstaValido = false;
					}
					if (!dadosEndereco.emissaoMatricula || !trim(dadosEndereco.emissaoMatricula.value)) {
						errosDoEnderecoAtual.emissaoMatricula = ['A data de emissão é obrigatória.'];
						esteEnderecoEstaValido = false;
					} else if (!/^\d{4}-\d{2}-\d{2}$/.test(dadosEndereco.emissaoMatricula.value)) {
						// O input type="date" do HTML5 envia o valor no formato YYYY-MM-DD
						errosDoEnderecoAtual.emissaoMatricula = ['Formato da data de emissão inválido.'];
						esteEnderecoEstaValido = false;
					}
					if (!dadosEndereco.zonaMatricula || !trim(dadosEndereco.zonaMatricula.value)) {
						errosDoEnderecoAtual.zonaMatricula = ['A zona da matrícula é obrigatória.'];
						esteEnderecoEstaValido = false;
					}

					if (!esteEnderecoEstaValido) {
						algumEnderecoIniciadoMasIncompleto = true;
					}
				} // Fim if (esteEnderecoFoiIniciado)

				if (Object.keys(errosDoEnderecoAtual).length > 0) {
					errors.areasPorEndereco[enderecoKey] = errosDoEnderecoAtual;
				}

				if (esteEnderecoFoiIniciado && esteEnderecoEstaValido) {
					countEnderecosPreenchidosCorretamente++;
				}
			}); // Fim chavesEnderecos.forEach

			if (countEnderecosPreenchidosCorretamente === 0) {
				// NENHUM endereço foi preenchido corretamente.
				if (algumEnderecoIniciadoMasIncompleto) {
					// O usuário tentou preencher algum(ns) endereço(s), mas todos continham erros.
					// Os erros individuais já estão em errors.areasPorEndereco[enderecoKey].
					// Podemos adicionar um erro geral se desejado, mas os específicos são mais úteis.
					// Ex: errors.geralDemolicaoTotal = ['Verifique os erros nos endereços. Pelo menos um endereço deve ser completamente preenchido e válido.'];
				} else if (chavesEnderecos.length > 0) {
					// Existem seções de endereço para preencher, mas o usuário não interagiu com NENHUMA delas.
					errors.geralDemolicaoTotal = [
						'Pelo menos um endereço deve ser completamente preenchido para Demolição Total.'
					];
				}
			}

			if (Object.keys(errors.areasPorEndereco).length === 0) {
				delete errors.areasPorEndereco; // Limpa se não houver erros específicos por endereço
			}
		} else if (numeroDeEnderecosDisponiveisParaPreenchimento > 0) {
			// Caso raro: Há endereços na lista principal do formulário, mas 'areasPorEndereco' está vazio.
			// Isso pode indicar um problema na inicialização do estado no frontend.
			errors.geralDemolicaoTotal = [
				'Não foram encontrados dados de endereço para preenchimento. Verifique se os endereços foram carregados corretamente.'
			];
		}
		// Se não há 'chavesEnderecos' e 'numeroDeEnderecosDisponiveisParaPreenchimento' é 0,
		// significa que não há endereços para este processo, então a validação de "pelo menos um" não se aplica.
	}

	if (verificaEnquadramentoDefinicao([E_DEMOLICAO_PARCIAL], definicao)) {
		if (size(data?.tiposMaterial) === 0) {
			errors.tiposMaterial = ['Você deve adicionar ao menos um "Tipo de material".'];
		} else {
			(data?.tiposMaterial || []).forEach((tm, i) => {
				if (size(tm.tipoConstrucao) === 0) {
					errors[`tipoConstrucao${i}`] = ['Você deve informar o tipo de construção'];
				}
				if (
					(!tm.areaDemolicaoRegular ||
						tm.areaDemolicaoRegular.value === 0 ||
						tm.areaDemolicaoRegular.value === '0.00' ||
						tm.areaDemolicaoRegular.value === '0,00') &&
					(!tm.areaDemolicaoIrregular ||
						tm.areaDemolicaoIrregular.value === 0 ||
						tm.areaDemolicaoIrregular.value === '0.00' ||
						tm.areaDemolicaoIrregular.value === '0,00')
				) {
					const errorMsg = 'Você deve informar pelo menos uma das áreas de demolição (regular ou irregular)';
					errors[`areaDemolicaoRegular${i}`] = [errorMsg];
					errors[`areaDemolicaoIrregular${i}`] = [errorMsg];
					delete tm.areaDemolicaoRegular;
					delete tm.areaDemolicaoIrregular;
				}

				// if (tipoForm === E_DEMOLICAO_PARCIAL) {
				// 	if (
				// 		!tm.areaPermanecerRegular ||
				// 		tm.areaPermanecerRegular.value === 0 ||
				// 		tm.areaPermanecerRegular.value === '0.00' ||
				// 		tm.areaPermanecerRegular.value === '0,00'
				// 	) {
				// 		errors[`areaPermanecerRegular${i}`] = ['Você deve informar a área à permanecer regular'];
				// 	}
				// }
			}); // each
		}
	}

	if (
		verificaEnquadramentoDefinicao(
			[
				E_RECICLAGEM_USO_PARCIAL,
				E_RECICLAGEM_USO_TOTAL,
				E_DESMEMBRAMENTO_UNIFICACAO,
				E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL,
				E_DESMEMBRA_UNIFICA_RECICLA_USO_PARCIAL
			],
			definicao
		)
	) {
		// if (E_RECICLAGEM_USO_TOTAL === tipoForm) {
		// 	if (!data?.areaReciclar) {
		// 		errors.areaReciclar = ['O campo "Área a reciclar" é obrigatório'];
		// 	}
		// }
		if (verificaEnquadramentoDefinicao([E_RECICLAGEM_USO_PARCIAL], definicao)) {
			if (!data?.areaReciclar) {
				errors.areaReciclar = ['O campo "Área a reciclar" é obrigatório'];
			}

			// if (!data?.numeroEconomias) {
			// 	errors.numeroEconomias = ['O campo "Número de economias" é obrigatório'];
			// }

			if (size(trim(get(data, 'planoDiretor.dadosSubunidades'))) === 0) {
				errors.planoDiretor = ['O campo "Plano diretor" é obrigatório, com pelo menos uma subunidade'];
			} else {
				(data?.planoDiretor?.dadosSubunidades || []).forEach(su => {
					if (size(trim(get(su, 'dadosAtividades'))) === 0) {
						errors.planoDiretor = [
							'O campo "Plano diretor" é obrigatório, com pelo menos uma atividade em cada subunidade selecionada'
						];
					} else {
						// é multifamiliar?
						if (get(su, 'dadosAtividades', []).some(atv => get(atv, 'atividadeAnexo52.item') === '1.3.')) {
							if (!data?.areaTotalMatriculaLote) {
								errors.areaTotalMatriculaLote = ['O campo é obrigatório'];
							}
							if (!data?.numeroEconomiasTotais) {
								errors.numeroEconomiasTotais = ['O campo é obrigatório'];
							}
							// obrigatoriedade removida na história 61498 item 1.5
							// if (!data?.quotaIdealTotalProjeto) {
							// 	errors.quotaIdealTotalProjeto = ['O campo é obrigatório'];
							// }
							// if (!data?.atendeQuotaIdeal) {
							// 	errors.atendeQuotaIdeal = ['O campo é obrigatório'];
							// }
						}
					}
				});
			}
		}
		if (
			verificaEnquadramentoDefinicao(
				[E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL, E_DESMEMBRA_UNIFICA_RECICLA_USO_PARCIAL],
				definicao
			)
		) {
			// if (!data?.areaReciclar) {
			// 	errors.areaReciclar = ['O campo "Área a reciclar" é obrigatório'];
			// }

			// if (!data?.numeroEconomias) {
			// 	errors.numeroEconomias = ['O campo "Número de economias" é obrigatório'];
			// }

			if (size(trim(get(data, 'planoDiretor.dadosSubunidades'))) === 0) {
				errors.planoDiretor = ['O campo "Plano diretor" é obrigatório, com pelo menos uma subunidade'];
			} else {
				(data?.planoDiretor?.dadosSubunidades || []).forEach(su => {
					if (size(trim(get(su, 'dadosAtividades'))) === 0) {
						errors.planoDiretor = [
							'O campo "Plano diretor" é obrigatório, com pelo menos uma atividade em cada subunidade selecionada'
						];
					}
				});
			}
			if (!data?.termoQuantoAreaOcupacaoIntensiva) {
				errors.termoQuantoAreaOcupacaoIntensiva = ['É necessário concordar com o termo acima'];
			}
		}
		if (
			verificaEnquadramentoDefinicao([E_DESMEMBRAMENTO_UNIFICACAO, E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL], definicao)
		) {
			if (!data?.l6Option) {
				errors.l6Option = ['Você deve selecionar esta opção'];
			} else {
				if (data?.l6Option.indexOf('economias') > -1) {
					if (!data?.numeroEconomiasAtuais && !data?.numeroEconomiasPropostas) {
						errors.numeroEconomiasPropostas = ['Você deve informar ao menos um dos campos de número de economias'];
					}
					if (verificaEnquadramentoDefinicao([E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL], definicao)) {
						if (!data?.economiasDesmembrarUnificar && !data?.economiasDesmembradasUnificadas) {
							errors.economiasDesmembradasUnificadas = [
								'Você deve informar ao menos um dos campos de descrição deeconomias para desmembramento ou unificação'
							];
						}
					}
				}
				if (data?.l6Option.indexOf('boxes') > -1) {
					if (!data?.numeroBoxesAtuais && !data?.numeroBoxesPropostos) {
						errors.numeroBoxesPropostos = ['Você deve informar ao menos um dos campos de número de boxes'];
					}
					if (verificaEnquadramentoDefinicao([E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL], definicao)) {
						if (!data?.boxesDesmembrarUnificar && !data?.boxesDesmembradosUnificados) {
							errors.boxesDesmembradosUnificados = [
								'Você deve informar ao menos um dos campos de descrição de boxes para desmembramento ou unificação'
							];
						}
					}
				}
			}
		}
	}

	if (
		verificaEnquadramentoDefinicao(
			[
				E_RECICLAGEM_USO_PARCIAL,
				E_RECICLAGEM_USO_TOTAL
				//E_DESMEMBRAMENTO_UNIFICACAO,
				//E_DESMEMBRA_UNIFICA_RECICLA_USO_TOTAL
			],
			definicao
		)
	) {
		// Coloque a lógica de validação de impactoUrbano e viabilidadeUrbanistica aqui
		const impactoUrbano = data.projetoImpactoUrbano;
		const viabilidadeUrbanistica = data.projetoViabilidaUrbanistico;
		const capConstrutiva = data.capacidadeConstrutiva;
		const reciclagem = data.reciclagemUso;

		// Se impactoUrbano é 'sim', viabilidadeUrbanistica também deve ser 'sim'
		if (impactoUrbano === 'sim' && viabilidadeUrbanistica !== 'sim') {
			errors.projetoViabilidaUrbanistico = ['É necessário marcar "Sim" para viabilidade urbanística.'];
		}

		// Se impactoUrbano não está marcado
		if (!impactoUrbano) {
			errors.projetoImpactoUrbano = ['Este campo é obrigatório.'];
		}

		// Se capacidadeConstrutiva é 'sim', reciclagem também deve ser 'sim'
		if (capConstrutiva === 'nao' && reciclagem !== 'sim') {
			errors.reciclagemUso = ['É necessário marcar "Sim" para RECICLAGEM DE USO.'];
		}
		// Se capacidadeConstrutiva não está marcado
		if (!capConstrutiva) {
			errors.capacidadeConstrutiva = ['Este campo é obrigatório.'];
		}
	}

	return errors;
};
